module.exports = __webpack_public_path__ + "static/media/SC.9036a00a.svg";